import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import FileUpload from '../services/files-upload-service';


export const uploadSubpoenaDetailsFiles = createAsyncThunk('subpoenaDetailsFiles/UploadSubpoenaDetailsFiles', async (payload) => {
    const response = await FileUpload.Upload(payload);
    return response.data;
});

export const deleteSubpoenaDetailsFiles = createAsyncThunk('subpoenaDetailsFiles/DeleteSubpoenaDetailsFiles', async (payload) => {
    const response = await FileUpload.Upload(payload);
    return response.data;
});

export const subpoenaDetailsFilesSlice = createSlice({
    name: 'subpoenaDetailsFiles',

    initialState: {
        subpoenaDetailsFiles: [],
        status: 'idle',
        error: null,
    },

    reducers: {
        resetSubpoenaDetailsFilesStatus: (state) => {
            state.status = 'idle';
        },
        resetSubpoenaDetailsFiles: (state) => {
            state.subpoenaDetailsFiles = [];
        },
    },

    extraReducers: {
        [uploadSubpoenaDetailsFiles.pending]: (state, action) => {
            state.status = 'loading';
        },
        [uploadSubpoenaDetailsFiles.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.subpoenaDetailsFiles = state.subpoenaDetailsFiles.concat(action.payload);
        },
        [uploadSubpoenaDetailsFiles.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },

        [deleteSubpoenaDetailsFiles.pending]: (state, action) => {
            state.status = 'loading';
        },
        [deleteSubpoenaDetailsFiles.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.subpoenaDetailsFiles = [];
        },
        [deleteSubpoenaDetailsFiles.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    }
});


export const {
    resetSubpoenaDetailsFilesStatus,
    resetSubpoenaDetailsFiles,
} = subpoenaDetailsFilesSlice.actions;


export default subpoenaDetailsFilesSlice.reducer;


export const selectAllSubpoenaDetailsFiles = state => {
    return state.subpoenaDetailsFiles;
};